// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TC0Qm","innerContainer":"styles_innerContainer__Q3Rbq"};